import { Skeleton,Stack } from "@mui/material";

export default function Loading() {
  return (
    <Stack direction="column" width="100%" spacing={2}>
      <Stack direction="row" justifyContent="space-between">
        <Stack spacing={1} width="100%">
          <Skeleton variant="text" height={30} width={180} />
          <Skeleton variant="text" height={30} width={220} />
          <Skeleton variant="rectangular" height={30} width={150} />
        </Stack>
        <Stack alignItems="center" spacing={1}>
          <Skeleton variant="circular" width={120} height={120} />
          <Skeleton variant="rounded" width={120} height={36} />
        </Stack>
      </Stack>
      <Stack direction="row" spacing={2}>
        <Stack width="100%" spacing={2}>
          <Skeleton variant="rounded" height={56} />
          <Skeleton variant="rounded" height={56} />
          <Skeleton variant="rounded" height={56} />
        </Stack>
        <Stack width="100%" spacing={2}>
          <Skeleton variant="rounded" height={56} />
          <Skeleton variant="rounded" height={56} />
          <Skeleton variant="rounded" height={80} />
        </Stack>
      </Stack>

      {/* AUTOCOMPLETE */}
      <Stack spacing={2}>
        <Skeleton variant="rounded" height={56} />
        <Skeleton variant="rounded" height={56} />
      </Stack>
    </Stack>
  );
}